import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ResponsiveDirective } from './responsive/responsive.directive';
import { ResponsiveDebugComponent } from './responsive-debug/responsive-debug.component';
import { ResponsiveShellComponent } from './responsive-shell/responsive-shell.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    ResponsiveDebugComponent,
    ResponsiveShellComponent,
    ResponsiveDirective,
  ],
  exports: [
    ResponsiveDebugComponent,
    ResponsiveShellComponent,
    ResponsiveDirective,
  ],
})
export class RsSharedUiBrandModule {}
